module.exports = [{
      plugin: require('D:/www/bananasestancia/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
